module.exports = __webpack_public_path__ + "img/article10-2.fe313e96.jpg";